import React, { useState } from "react";
import { usePageSetting } from "tsi-common-react/src/utils/settings";

import { NearbyStoresSearch } from "../../RetailLocator/containers/NearbyStoresSearch";
import { SiteSearchBar } from "./SiteSearchBar";

export const SearchNav = (): React.ReactNode => {
    const [isSiteSearchOpen, setIsSiteSearchOpen] = useState(false);
    const enableStoreSearch = usePageSetting("retail_locator_display_enabled");

    const onOpenSearch = () => {
        setIsSiteSearchOpen(true);
    };

    const onCloseSearch = () => {
        setIsSiteSearchOpen(false);
    };

    return (
        <>
            {enableStoreSearch && (
                <NearbyStoresSearch isSiteSearchOpen={isSiteSearchOpen} />
            )}
            <SiteSearchBar
                isSearchOpen={isSiteSearchOpen}
                onOpenSearch={onOpenSearch}
                onCloseSearch={onCloseSearch}
            />
        </>
    );
};
